export enum PartnerTimeSlotStatusEnums {
    FREE = "FREE",
    BLOCKED = "BLOCKED",
    CK_BLOCKED = "CK_BLOCKED",
}